module.exports = __webpack_public_path__ + "static/the-myth-of-mental-illness-869958528787b20da6763d719f07221b.jpg";